module.exports = __webpack_public_path__ + "img/42-03.de73ee0d.png";